/* eslint-disable no-eval */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
import React from 'react';
import groupBy from 'lodash.groupby';

import { dataConstants } from '../../constants';

const { PLOT_DATA_TYPE } = dataConstants;

class FormulaUtil {
  bracketText = /[\[].+?[\]]/g;
  opers = /[-+;/*,]/;
  multioperator = /[-+/*.:@]\s*[-+/*.:@]+/g;
  multiCaret = /([\^][\^])+/g;
  missingoperatorbeg = /\w\s*\(/g;
  missingoperatorend = /\)\s*\w+/g;
  removeWhiteSpace = /[{}\s]+/g;
  beginOprReg = /[.)+*/-]/;
  endOprReg = /[.(+*/-]/;
  splitSquares = /\[.*?\]/g;
  squareFormat = /\[[TQ]?,?(19|20)\d\d[- /.](0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])\]/;
  squareBracketBoj = /[A-Za-z][A-Za-z.|]*\[.*?\]/g;
  codeSymbolArr = ['$', '^', ':'];

  getSymbolCodes = (formulaStr, ticks = [], sorted = false) => {
    let tickers = ticks;
    let symbolCodes = formulaStr && formulaStr.selectedBreak ? formulaStr.selectedBreak?.replace(this.bracketText, '').replace(/[(){}\s]+/g, '') : formulaStr?.replace(this.bracketText, '').replace(/[(){}\s]+/g, '');
    symbolCodes = symbolCodes && symbolCodes?.split(this.opers);

    symbolCodes && symbolCodes.forEach(symbolCode => {
      if (tickers.findIndex(item => item.toLowerCase() === symbolCode.toLowerCase()) < 0 && isNaN(symbolCode)) tickers.push(symbolCode);
    });

    if (sorted) tickers = tickers.sort((a, b) => b.length - a.length);

    return tickers;
  };

  convertArrToStringfy = arr => {
    const codes = arr.reduce((symbolCodes, item) => `${symbolCodes}, \\"${item}\\"`, '');

    return codes.substr(2, codes.length - 1);
  };

  constructTickers = (ticks = [], codes = []) => {
    let tickers = ticks;
    // formulaStr = formulaStr.replace(this.bracketText,"").replace(/[(){}\s]+/g,"");
    // let tickers = formulaStr.split(this.opers);

    // let tickers = this.getSymbolCodes(formulaStr);

    tickers = tickers.reduce((t, item) => {
      const dotIndex = item.indexOf('.');
      const lastIndex = item.length - 1;

      if (dotIndex < 0) t.push({ ticker: item, code: '', type: PLOT_DATA_TYPE.SERIES });
      else {
        const code = item.substr(dotIndex + 1, lastIndex - dotIndex);
        const ticker = item.substr(0, dotIndex);
        const seriescode = Object.keys(codes).length > 0 ? codes[code.toUpperCase()].type : null;

        const tickerItem = { ticker, code, type: seriescode ? seriescode.key : PLOT_DATA_TYPE.SERIES };

        t.push(tickerItem);
        // if(ticks.findIndex(tick => tick.ticker.toLowerCase() === tickerItem.ticker.toLowerCase() && tick.code.toLowerCase() === tickerItem.code.toLowerCase()) < 0) {
        //     tickers.push(tickerItem);
        // }
      }

      return t;
    }, []);

    return tickers;
  };

  constructorData = (tickers = []) => {
    const plotTypeWiseData = groupBy(tickers, ticker => ticker.type);
    const plotData = {};

    Object.keys(plotTypeWiseData).forEach(key => {
      const tickWiseData = groupBy(plotTypeWiseData[key], item => item.ticker);
      const plotTickers = {};

      Object.keys(tickWiseData).forEach(tickKey => {
        let codes = tickWiseData[tickKey].reduce((code, ticker) => `${code}, \\"${ticker.code}\\"`, '');
        codes = codes.substr(2, codes.length - 1);
        plotTickers[tickKey] = codes;
      });

      plotData[key] = plotTickers;
    });

    return plotData;
  };

  constructPlotData = (data = {}) => {
    const plottedData = {
      series_data: [],
      stock_data: [],
      seq_series_data: [],
    };

    Object.keys(data).forEach(key => {
      data[key] = data[key] || [];
      data[key].forEach(item => {
        if (item)
          plottedData[item.type.toLowerCase()].push({ ...item, recordDate: item.recordDate ? new Date(item.recordDate) : null });
      });
    });

    // if (Object.keys(data).length > 0) {
    //   let series_data = Object.keys(data).filter(key => {
    //     const type = key.split('_');
    //     return type[1] === PLOT_DATA_TYPE.SERIES;
    //   });

    //   let stock_data = Object.keys(data).filter(key => {
    //     const type = key.split('_');
    //     return type[1] === PLOT_DATA_TYPE.STOCK;
    //   });

    //   series_data = series_data.map(key => data[key]);
    //   stock_data = stock_data.map(key => data[key]);

    //   plottedData.series_data = series_data.reduce((data, items) => data.concat(items), []);

    //   plottedData.stock_data = stock_data.reduce((data, items) => data.concat(items), []);

    //   plottedData.series_data = plottedData.series_data.map(item => ({ ...item, recordDate: parseDate(item.recordDate) }));

    //   plottedData.stock_data = plottedData.stock_data.map(item => ({ ...item, recordDate: parseDate(item.recordDate) }));
    // }

    return plottedData;
  };

  getErrorPositions = (str, regX) => {
    let match;
    // let indexes = [];
    let errorStr = null;
    let lastCharIndex = -1;
    while ((match = regX.exec(str))) {
      const preStr = str.substr(lastCharIndex + 1, match.index);
      const htmlStr = (
        <span>
          {preStr}
          <span className="error">{str.substr(match.index, match[0].length)}</span>
        </span>
      );
      lastCharIndex = match.index + match[0].length;
      errorStr = errorStr ? errorStr + htmlStr : htmlStr;
    }

    return errorStr;
  };

  validateSquare = formula => {
    const sqaures = formula.match(this.splitSquares);
    const str = formula;

    const error = sqaures.reduce((errorStr, square) => {
      const prefix = str.substr(0, str.indexOf('['));
      let htmlStr = null;
      if (!square.match(this.squareFormat)) {
        htmlStr = <span className="error">{square}</span>;
        htmlStr = (
          <span>
            {prefix}
            {htmlStr}
          </span>
        );
      } else {
        htmlStr = (
          <span>
            {prefix}
            {square}
          </span>
        );
      }

      return errorStr ? errorStr + htmlStr : htmlStr;
    }, null);
    // if(!squareStr.match(this.squareFormat)) {
    //     return {isValid: false, error: <span></span>}
    // }
    if (error) {
      return { isValid: false, error: <span>{error} invalid format eg: AAPL.REV[Q, 2010-10-10]</span> };
    }
    return { isValid: true, error: null };
  };

  validateFormula = formula => {
    const str = formula.replace(this.bracketText, '').replace(this.removeWhiteSpace, '');
    // const strArr = str.split(this.opers);
    let regX = {};
    const beginChar = formula[0];

    if (beginChar.match(this.beginOprReg)) {
      return {
        isValid: false,
        error: (
          <span>
            <span className="error">{beginChar}</span>
            {formula.substr(1, formula.length)} begin character should not be operator or dot.
          </span>
        ),
      };
    }

    if (str.match(this.multioperator)) {
      regX = new RegExp(this.multioperator);
      return { isValid: false, error: <span>{this.getErrorPositions(str, regX)} adjacent multiple operators.</span> };
    }

    if (str.match(this.multiCaret)) {
      regX = new RegExp(this.multiCaret);
      return { isValid: false, error: <span>{this.getErrorPositions(str, regX)} adjacent multiple carets.</span> };
    }

    if (str.match(this.missingoperatorbeg)) {
      regX = new RegExp(this.missingoperatorbeg);
      return { isValid: false, error: <span>{this.getErrorPositions(str, regX)} missing operator before open bracket.</span> };
    }
    if (str.match(this.missingoperatorend)) {
      regX = new RegExp(this.missingoperatorend);
      return { isValid: false, error: <span>{this.getErrorPositions(str, regX)} missing operator after close bracket.</span> };
    }

    if (formula.match(this.splitSquares) && formula.match(this.splitSquares).length > 0) {
      const errorStr = this.validateSquare(formula);

      if (!errorStr.isValid) return errorStr;
    }

    return { isValid: true, error: null };
  };

  validateSeriesCodes = (seriesCodes, data, allData = true) => {
    // const str = formula.replace(this.bracketText, '').replace(this.removeWhiteSpace, '');
    // const tickers = str.split(this.opers);

    // const invalidCodes = data.filter(item => item.type === PLOT_DATA_TYPE.UNKNOWN);
    // data.forEach((item , index) => {
    //   if(item.length === 0) {

    //   }
    // });
    // let lastCharIndex = 0;
    // let errorStr;
    // let htmlStr;
    // let isValid = true;
    if (!data) {
      return { isValid: false, error: 'data is not available for respective formula' };
    }

    const keys = Object.keys(data);

    if (allData && (keys.find(key => !data[key] || (data[key] && data[key].length === 0)))) {
      return { isValid: false, error: 'data is not available for respective formula' };
    } else {
      const cnt = keys.reduce((c, d) => d.length === 0 ? c + 1 : c, 0);
      if (cnt === keys.length) return { isValid: false, error: 'data is not available for respective formula' };
    }

    // const error = keys.reduce((errorStr, key, index) => {
    //   const item = data[key];
    //   lastCharIndex += seriesCodes[index].length;
    //   if(!item || (item && item.length === 0)) {
    //     htmlStr = (
    //       <span>
    //         <span className="error">{seriesCodes[index]}</span>
    //         {lastCharIndex < formula.length - 1 ? formula.charAt(lastCharIndex) : ''}
    //       </span>
    //     );
    //     isValid = false;
    //   }
    //   else {
    //     htmlStr = <span>{`${seriesCodes[index]}${lastCharIndex < formula.length - 1 ? formula.charAt(lastCharIndex) : ''}`}</span>;
    //   }

    //   lastCharIndex += 1;

    //   return errorStr ? (
    //     <span>
    //       {errorStr}
    //       {htmlStr}
    //     </span>
    //   ) : (
    //     htmlStr
    //   );
    // }, null);

    // if(!isValid) {
    //   return { isValid, error: <span>{error} formula contains invalid series codes.</span> };
    // }

    return { isValid: true, error: null };
  };

  lazyValidation = formula => {
    const lastChar = formula[formula.length - 1];
    const matchOpenBrackets = formula.match(new RegExp('\\(', 'g'));
    const matchCloseBrackets = formula.match(new RegExp('\\)', 'g'));
    const symbolCodes = this.getSymbolCodes(formula, [], true);
    let evaluation;

    if (lastChar.match(this.endOprReg)) {
      return {
        isValid: false,
        error: (
          <span>
            {formula.substr(0, formula.length - 1)}
            <span className="error">{`${lastChar} `}</span>
            end character should not be operator or dot.
          </span>
        ),
      };
    }

    if (matchOpenBrackets || matchCloseBrackets) {
      if (
        (!matchOpenBrackets && matchCloseBrackets) ||
        (matchOpenBrackets && !matchCloseBrackets) ||
        matchOpenBrackets.length !== matchCloseBrackets.length
      ) {
        return { isValid: false, error: 'Open and close brackets are not matching.' };
      }
    }

    const exp = symbolCodes.reduce((e, code) => {
      //const nCode = code.replace(/\$/g, '\\$').replace(/\^/g, '\\^').replace(/\:/g, '\\:');
      return e.replace(new RegExp(this.getCodeSymbolEscape(code).toUpperCase(), 'g'), 1)
    }, formula.toUpperCase());

    try {
      evaluation = eval(exp);
    } catch (err) {
      return { isValid: false, error: `${formula} is not a valid expression.` };
    }

    return { isValid: true, error: null };
  };


  getSquareItems = exp => {
    let matches = exp && exp.selectedBreak ? exp.selectedBreak?.match(this.squareBracketBoj) : exp?.match(this.squareBracketBoj);

    if (matches && matches.length > 0) {
      matches = matches.map(d => {
        return { code: d.replace(/\[.*?\]/g, ''), key: d.match(/\[.*?\]/g)[0].replace(/[\[\]]/g, ''), item: d };
      });
    }

    return matches || [];
  }

  getCodeSymbolEscape = (code = '') => {
    this.codeSymbolArr.forEach(s => {
      code = code.replace(new RegExp(`\\${s}`, 'g'), `\\${s}`);
    });

    return code;
  }
}


const formulaUtil = new FormulaUtil();

export default formulaUtil;
